module.exports = __webpack_public_path__ + "media/icons/tablica_rejestracyjna@3x-28671f4b.svg";